import { barbaInit } from './barba'; barbaInit();
import { test } from './test'; test();
import { pencil } from './pencil'; pencil();
import { video } from './video'; video();
